'use strict';

const { gsap } = require("gsap");
const { CustomEase } = require("gsap/CustomEase");
const animations = require('../animation.product-finder');
const stepper = require('../stepper');

const getStepType = (step) => {
    const stepTypeClass = Array.from(step.classList).find((className) => className.startsWith('step__type--'));
    return stepTypeClass ? stepTypeClass.split('step__type--')[1] : '';
};

$(document).on('click', '.start-over', (e) => {
    e.preventDefault();

    if (window.isLoading) {
        return;
    }

    // Remove recommendation class to the product finder container
    $('#product-finder-container').removeClass('product-finder-container--recommendation');
    // Remove recommendation class to the footer
    $('body').removeClass('step__type--recommendation');
    $('footer').removeClass('footer--recommendation').attr('aria-hidden', 'true');

    //region Get previous steps (remove the first one)
    const previousSteps = $('.step').toArray().reverse().slice(1);
    const duration = 1;

    const timeline = gsap.timeline({ // eslint-disable-line no-undef
        defaults: {
            duration: duration,
            ease: CustomEase.create('custom', 'M0,0 C0.59,0.2 0.25,1 1,1 '), // eslint-disable-line no-undef
        },
    });

    timeline.fromTo(
        '.step__type--recommendation',
        {
            position: 'absolute',
            yPercent: 0,
            duration: duration / previousSteps.length,
        },
        {
            yPercent: 100,
        }
    );

    previousSteps.forEach((step, index) => {
        const isLast = index === previousSteps.length - 1;

        const stepType = getStepType(step); // eslint-disable-line no-undef
        animations.animateNextStep(step, stepType, timeline, true);

        if (isLast) {
            gsap.to('.stepper__container', { autoAlpha: 0 }); // eslint-disable-line no-undef
            timeline.set( step, { position: 'relative' }, '>' );
        } else {
            animations.animatePreviousStep(step, stepType, timeline, true);
        }
    });
    //endregion

    // Remove recommendation step
    timeline.call( () => { $('.step__type--recommendation').remove(); }, null, '>' );

    // Reset stepper
    stepper.updateCurrentStepNumber(0);
});
